export enum FileType {
    Unknown = 0,
    Other = 1,
    ID_Passport = 2,
    VoidedCheck = 6,
    BankDocument = 7,
    CertificateOfInsurance = 8,
    ID_Front = 9,
    ID_Back = 10,
    ID_FrontAndBack = 11,
    Clear = 12,

    // Business formation
    ArticlesOfOrganization = 13,
    CertificateOfGoodStanding = 14,
    OperatingAgreement = 15,
    AssumedNameCertificate = 16,
    AmendmentToArticles = 17,
    CertificateOfReinstatement = 18,

    // Tax & identity
    FeinTaxLetter = 19,
    SocialSecurityCard = 20,
    ItinCard = 21,
    IrsFormW9 = 22,
    WorkVisa = 23,

    // Address
    UtilityBill = 24,
    PhoneStatement = 25,

    // Contracts
    LetterOfRelease = 26,
    CompetitorFactoringAgreement = 27,
    BuySellAgreement = 28,
    LeaseAgreement = 29,
    OwnerOperatorAgreement = 30,
    MasterServiceAgreement = 31,

    // Invoice documents
    InvoicePackage = 32,
    Invoice = 33,
    BillOfLading = 34,
    RateConfirmation = 35,
    ProofOfDelivery = 36,
    RemittanceAdvice = 37,

    // Carrier authority
    FmcsaAuthorityLetter = 38,

    // Internal diligence reports
    UccSearchResults = 39,
    MiddeskBusinessReport = 40,
    OfacSearchResults = 41,
    RiskInformReport = 42,
    NoticeOfAssignment = 43,
    SecretaryOfStateEntitySearch = 44,
    UccFiling = 45,
}
